/**
 * chain-eos/mechat/constants.ts — on-chain messenger (`mechatmechat`) constants.
 *
 * `mechatmechat` is the encrypted direct-message contract used by the PayCash
 * wallet on EOS/Vaulta mainnet. It has a single action, `senddm`, and no tables —
 * messages live only in the action history, so reading a conversation means
 * querying Hyperion, not `get_table_rows`.
 */

/** Deployed messenger contract account on EOS/Vaulta mainnet. */
export const MECHAT_CONTRACT = 'mechatmechat'

/** The contract's only action. */
export const MECHAT_ACTION = 'senddm'

/**
 * Maximum message length, in characters (UTF-16 code points as counted by JS).
 *
 * This is a product limit, NOT a protocol limit: the text travels in the action's
 * `cipher_text` field (a `bytes` blob), not in a transfer `memo`, so the chain
 * itself would allow far more. We cap at 256 to keep every message inside one
 * cheap transaction and in line with what PayCash sends today (observed on-chain:
 * p50 80 bytes, p99 480 bytes, max ~1.3 KB of ciphertext).
 *
 * Ciphertext cost for 256 chars: ~272 bytes (ASCII), ~528 bytes (Cyrillic),
 * ~1040 bytes (emoji) — UTF-8 encoding happens before encryption.
 */
export const MECHAT_MAX_MESSAGE_CHARS = 256

/** Below this many remaining characters the UI counter turns red. */
export const MECHAT_COUNTER_WARN_CHARS = 30
